import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { reset, setMessages, setTotal, setLoading } from './actions';

const messagesReducer = handleActions(
  {
    [setMessages.toString()]: (_, { payload }) => payload,
    [reset.toString()]: () => []
  },
  []
);

const totalReducer = handleActions(
  {
    [setTotal.toString()]: (_, { payload }) => payload,
    [reset.toString()]: () => 0
  },
  0
);

const loadingReducer = handleActions(
  {
    [setLoading.toString()]: (_, { payload }) => payload,
    [reset.toString()]: () => false
  },
  false
);

export default combineReducers({
  messages: messagesReducer,
  total: totalReducer,
  loading: loadingReducer
});
